import { ReactNode } from 'react';

import { clsx } from 'clsx';

import { BreadcrumbItemType } from '@shared/types/global';
import { Breadcrumbs } from '@shared/ui/Breadcrumbs';
import { Container } from '@shared/ui/Container';

import cls from './PageHead.module.scss';

type PageHeadProps = {
  className?: string;
  breadcrumbs?: BreadcrumbItemType[];
  title?: ReactNode;
  subtitle?: string;
};

export const PageHead = ({ className, title, breadcrumbs, subtitle }: PageHeadProps) => {
  return (
    <div className={clsx(cls.wrap, className)}>
      <Container>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs
            className={cls.breadcrumbs}
            data={breadcrumbs}
          />
        )}
        {title && <h1 className={cls.title}>{title}</h1>}
        {subtitle && (
          <div
            className={cls.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
      </Container>
    </div>
  );
};
